import React from 'react';
import PropTypes from 'prop-types';

import styles from './ProgressBar.module.scss';

function ProgressBar({ progress }) {
  return (
    <div className={styles.bar}>
      <div className={styles.bar_inner} style={{ width: `${progress < 100 ? progress : 100}%` }} />
    </div>
  );
}

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
};

export default ProgressBar;
